var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15V18H15.5V20H18.5V23H20.5V20H23.5V18H20.5V15H18.5ZM13.8 21H5.5C4.4 21 3.5 20.1 3.5 19V5C3.5 3.9 4.4 3 5.5 3H19.5C20.6 3 21.5 3.9 21.5 5V13.3C20.9 13.1 20.2 13 19.5 13C18.4 13 17.3 13.3 16.4 13.9L15 12L11.5 16.5L9 13.5L5.5 18H13.6C13.5 18.3 13.5 18.7 13.5 19C13.5 19.7 13.6 20.4 13.8 21Z",
    fill: "#181038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.4d6a85214ae0829b77c3270bce841308.svg";
export { ForwardRef as ReactComponent };